import { call, cancel, cancelled, fork, put, take } from 'redux-saga/effects'

import { APP_NAME } from '../../app/constants'
import { getAvatar } from '../../features/avatar/avatarSlice'
import { getBalance } from '../../features/balance/balanceSlice'
import { getCollection } from '../../features/collection/collectionSlice'
import { getUserCollection } from '../../features/collection/userCollectionSlice'
import { getLeaderboard } from '../../features/leaderboard/leaderboardSlice'
import { getShopItems } from '../../features/shopItems/shopItemsSlice'
import { getEpoch } from '../../features/staking/epochSlice'
import { setUser } from '../../features/user/userSlice'
import { getProfile } from '../../features/userprofile/profileSlice'
import Wallets from '../../ual/wallets'

export function waxAPI() {
  return new Promise(async (resolve, reject) => {
    try {
      const users = await Wallets.getWallet().loginUser(
        Wallets.getWax(),
        APP_NAME,
      )
      resolve(users)
    } catch (error) {
      console.log('error -> ', error)
      reject(error)
    }
  })
}

export function* resolveLogin() {
  yield put(getCollection())
  try {
    const userAccount = yield call(waxAPI)
    yield put(
      setUser({
        type: 'LOGIN_SUCCESS',
        userAccount: userAccount[0],
        isWax: true,
        isAnchor: false,
      }),
    )
    yield put(getEpoch())
    yield put(getUserCollection())
    yield put(getLeaderboard())
    yield put(getAvatar())
    yield put(getProfile())
    yield put(getBalance())
    yield put(getShopItems())
  } catch (error) {
    yield put(setUser({ type: 'LOGIN_ERROR', error }))
  } finally {
    if (yield cancelled()) {
      yield put(setUser({ type: 'LOGIN_CANCELLED' }))
    }
  }
}

export function* loginFlow() {
  while (true) {
    yield put(setUser({ type: 'GET_USER' }))
    const task = yield fork(resolveLogin)
    yield put(getUserCollection())
    const action = yield take(['LOGOUT', 'LOGIN_ERROR'])
    if (action.type === 'LOGOUT') {
      yield cancel(task)
    }
  }
}

export function* autoLogin() {
  // let isAutoLoginAvailable = yield wax.isAutoLoginAvailable();
  // if (isAutoLoginAvailable) {
  //   let userAccount = wax.userAccount;
  //   let pubKeys = wax.pubKeys;
  //   yield put(setUser({ active: pubKeys[0], owner: pubKeys[1], userAccount }));
  //   yield;
  // } else {
  //   return;
  // }
}

export function* sign() {
  // if (!wax.api) {
  //   return document.getElementById('response').append('* Login first *');
  // }
  // try {
  //   const result = yield wax.api.transact(
  //     {
  //       actions: [
  //         {
  //           account: 'eosio',
  //           name: 'delegatebw',
  //           authorization: [
  //             {
  //               actor: wax.userAccount,
  //               permission: 'active',
  //             },
  //           ],
  //           data: {
  //             from: wax.userAccount,
  //             receiver: wax.userAccount,
  //             stake_net_quantity: '0.00000001 WAX',
  //             stake_cpu_quantity: '0.00000000 WAX',
  //             transfer: false,
  //             memo: 'This is a WaxJS/Cloud Wallet Demo.',
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       blocksBehind: 3,
  //       expireSeconds: 30,
  //     }
  //   );
  //   document.getElementById('response').append(JSON.stringify(result, null, 2));
  // } catch (e) {
  //   document.getElementById('response').append(e.message);
  // }
}
